// https://www.npmjs.com/package/vanilla-autokana

import { Controller } from '@hotwired/stimulus'

// eslint-disable-next-line no-irregular-whitespace
const kanaExtractionPattern = /[^ 　ぁあ-んー]/g
const kanaCompactingPattern = /[ぁぃぅぇぉっゃゅょ]/g

export default class extends Controller {
  static targets = [
    'name',
    'furigana',
  ]

  connect () {
    this.initializeValues()
  }

  initializeValues () {
    this.baseKana = ''
    this.furigana = ''
    this.isConverting = false
    this.ignoreString = ''
    this.input = ''
    this.values = []
  }

  focusNameInput () {
    this.onInput()
  }

  inputNameInput () {
    this.checkValue()
    if (this.isConverting) {
      this.onInput()
    }
  }

  setFurigana (newValues) {
    if (this.isConverting) return

    if (newValues) {
      this.values = newValues
    }

    this.furigana = this.baseKana + this.values.join('')
    if (this.hasFuriganaTarget) {
      this.furiganaTarget.value = this.furigana
    }
  }

  removeString (newInput) {
    if (newInput.indexOf(this.ignoreString) !== -1) {
      return String(newInput).replace(this.ignoreString, '')
    }
    const ignoreArray = this.ignoreString.split('')
    const inputArray = newInput.split('')
    for (let i = 0; i < ignoreArray.length; i += 1) {
      if (ignoreArray[i] === inputArray[i]) {
        inputArray[i] = ''
      }
    }
    return inputArray.join('')
  }

  checkConvert (newValues) {
    if (this.isConverting) return

    if (Math.abs(this.values.length - newValues.length) > 1) {
      const tmpValues = newValues
        .join('')
        .replace(kanaCompactingPattern, '')
        .split('')
      if (Math.abs(this.values.length - tmpValues.length) > 1) {
        this.onConvert()
      }
    } else if (
      this.values.length === this.input.length &&
      this.values.join('') !== this.input
    ) {
      if (this.input.match(kanaExtractionPattern)) {
        this.onConvert()
      }
    }
  }

  checkValue () {
    let newInput = this.nameTarget.value

    newInput = this.removeString(newInput)

    if (this.input === newInput) return // no changes

    this.input = newInput

    if (this.isConverting) return

    const newValues = newInput.replace(kanaExtractionPattern, '').split('')
    this.checkConvert(newValues)
    this.setFurigana(newValues)
  }

  onInput () {
    if (this.hasFuriganaTarget) {
      this.baseKana = this.furiganaTarget.value
    }
    this.isConverting = false
    this.ignoreString = this.nameTarget.value
  }

  onConvert () {
    this.baseKana = this.baseKana + this.values.join('')
    this.isConverting = true
    this.values = []
  }
}
